module.exports = __webpack_public_path__ + "static/media/cust-app.4afce584.jpg";